<template>
  <SkeletonLoader>
    <div class="wf-skeleton">
      <!-- Header: title + subtitle + stat pills + action button -->
      <div class="wf-skeleton__header">
        <div class="wf-skeleton__header-left">
          <div class="sk-line sk-line--title" style="width: 35%;"></div>
          <div class="sk-line sk-line--sm" style="width: 50%; margin-bottom: 0;"></div>
        </div>
        <div class="wf-skeleton__header-right">
          <div class="wf-skeleton__stat-pills">
            <div
              v-for="(pill, idx) in statPills"
              :key="'pill-' + idx"
              class="wf-skeleton__stat-pill"
            >
              <div class="sk-line sk-line--sm" :style="{ width: pill.labelWidth, marginBottom: 0 }"></div>
              <div class="sk-line sk-line--lg" :style="{ width: pill.valueWidth, marginBottom: 0 }"></div>
            </div>
          </div>
          <div class="sk-rect" style="width: 150px; height: 38px; border-radius: 6px;"></div>
        </div>
      </div>

      <!-- Filter bar: search input + 3 filter tag pills -->
      <div class="wf-skeleton__filters">
        <div class="sk-rect" style="width: 260px; height: 38px; border-radius: 6px;"></div>
        <div class="wf-skeleton__filter-tags">
          <div
            v-for="(tag, idx) in filterTags"
            :key="'tag-' + idx"
            class="sk-rect"
            :style="{ width: tag.width, height: '30px', borderRadius: '15px' }"
          ></div>
        </div>
      </div>

      <!-- Workflow cards -->
      <div class="wf-skeleton__cards">
        <div
          v-for="(card, idx) in cards"
          :key="'card-' + idx"
          class="wf-skeleton__card"
        >
          <div class="sk-circle sk-circle--lg" style="flex-shrink: 0;"></div>
          <div class="sk-col" style="flex: 3;">
            <div class="sk-line" :style="{ width: card.titleWidth }"></div>
            <div class="sk-line sk-line--sm" :style="{ width: card.descWidth, marginBottom: 0 }"></div>
          </div>
          <div class="wf-skeleton__card-badges" style="flex-shrink: 0;">
            <div class="sk-rect" :style="{ width: card.statusWidth, height: '24px', borderRadius: '12px' }"></div>
            <div class="sk-rect" :style="{ width: card.triggerWidth, height: '24px', borderRadius: '12px' }"></div>
          </div>
        </div>
      </div>
    </div>
  </SkeletonLoader>
</template>

<script>
import SkeletonLoader from '@/components/SkeletonLoader.vue';

export default {
  name: 'WorkflowListSkeleton',
  components: { SkeletonLoader },
  data() {
    return {
      statPills: [
        { labelWidth: '40px', valueWidth: '24px' },
        { labelWidth: '48px', valueWidth: '20px' },
        { labelWidth: '36px', valueWidth: '28px' },
      ],
      filterTags: [
        { width: '72px' },
        { width: '88px' },
        { width: '64px' },
      ],
      cards: [
        { titleWidth: '60%', descWidth: '80%', statusWidth: '68px', triggerWidth: '82px' },
        { titleWidth: '75%', descWidth: '65%', statusWidth: '56px', triggerWidth: '76px' },
        { titleWidth: '50%', descWidth: '70%', statusWidth: '72px', triggerWidth: '68px' },
        { titleWidth: '68%', descWidth: '55%', statusWidth: '60px', triggerWidth: '88px' },
      ],
    };
  },
}
</script>

<style lang="scss" scoped>
.wf-skeleton {
  padding: 20px;
}

.wf-skeleton__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 24px;
  gap: 16px;
}

.wf-skeleton__header-left {
  min-width: 0;
  flex: 1;
}

.wf-skeleton__header-right {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;
}

.wf-skeleton__stat-pills {
  display: flex;
  gap: 12px;
}

.wf-skeleton__stat-pill {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 8px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  min-width: 70px;
}

.wf-skeleton__filters {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
}

.wf-skeleton__filter-tags {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.wf-skeleton__cards {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.wf-skeleton__card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  margin-bottom: 12px;
}

.wf-skeleton__card-badges {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Tablet */
@media (max-width: 1024px) {
  .wf-skeleton__header {
    flex-direction: column;
  }

  .wf-skeleton__header-right {
    width: 100%;
    justify-content: space-between;
  }

  .wf-skeleton__stat-pills {
    flex-wrap: wrap;
  }
}

/* Mobile */
@media (max-width: 768px) {
  .wf-skeleton {
    padding: 12px;
  }

  .wf-skeleton__header-right {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .wf-skeleton__stat-pills {
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  .wf-skeleton__filters {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;

    .sk-rect {
      width: 100% !important;
    }
  }

  .wf-skeleton__filter-tags {
    flex-wrap: wrap;
  }

  .wf-skeleton__card {
    flex-wrap: wrap;
  }

  .wf-skeleton__card-badges {
    width: 100%;
    margin-top: 4px;
    padding-left: 60px;
  }
}
</style>
